/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import React from "react"
import { Col, Row, Progress, Flex } from "@duxton-web/ui"
import { useTranslation } from "common/utils/i18n"
import { StarRating } from "components/common/StarRating"
import _sortBy from "lodash/sortBy"
import _isEmpty from "lodash/isEmpty"
import { DisplayRatingProp } from "./types"
import { fontStyle } from "./shared"

const BasicRating: React.FC<DisplayRatingProp> = ({
  feedbackOverview,
  ratingCountFormatted,
}) => {
  const sortedRatingDistribution = !_isEmpty(
    feedbackOverview?.ratingDistribution,
  )
    ? _sortBy(feedbackOverview?.ratingDistribution, d => d.score).reverse()
    : []

  return (
    <Row
      align="middle"
      css={css({
        marginTop: 12,
      })}
    >
      <Col
        span={8}
        css={css({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 8,
        })}
      >
        <p
          css={css({
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: 32,
            lineHeight: "40px",
            margin: 0,
          })}
        >
          {feedbackOverview?.aggregatedRatingScore
            ? Math.round(feedbackOverview?.aggregatedRatingScore * 10) / 10
            : 0}
        </p>
        <StarRating rating={feedbackOverview?.aggregatedRatingScore || 0} />
        <p css={fontStyle}>
          {useTranslation(`merchant.reviews.card.title`, {
            "<x>": ratingCountFormatted.toString(),
          })}
        </p>
      </Col>
      <Col span={15}>
        {sortedRatingDistribution.map(dist => (
          <Flex
            align="baseline"
            gap={8}
            key={`feedback-overview-distribution-${dist.score}`}
            css={{
              height: "25px",
            }}
          >
            <p>{dist.score}</p>
            <Progress
              strokeColor="#FFBC05"
              percent={dist.countPercentage}
              showInfo={false}
            />
          </Flex>
        ))}
      </Col>
    </Row>
  )
}

export default BasicRating
